module.exports = "\t<img src=\"../../../../assets/nova_logo_omni.svg\" alt=\"OmniLogo\" class=\"logo\" />\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/print/logo/print-logo.component.html
// module id = ../../../../../src/app/shared/print/logo/print-logo.component.html
// module chunks = main